import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
import MainLayout from 'src/layouts/dashboard';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const HomePage = lazy(() => import('src/pages/home'));
const PoetsPage = lazy(() => import('src/pages/poets'));
const PoemsPage = lazy(() => import('src/pages/poems'));
const PoemDetailPage = lazy(() => import('src/pages/poem/[id]'));
const PoetDetailPage = lazy(() => import('src/pages/poet/[id]'));
const StatisticsPage = lazy(() => import('src/pages/statistics'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    path: '/',
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      { path: '', element: <HomePage /> },
      { path: 'poets', element: <PoetsPage /> },
      { path: 'poems', element: <PoemsPage /> },
      { path: 'statistics', element: <StatisticsPage /> },
      { path: 'poem/:id', element: <PoemDetailPage /> },
      { path: 'poet/:id', element: <PoetDetailPage /> },
    ],
  },
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [{ path: '404', element: <Page404 /> }],
  },
];
